/**
 * 页面收藏
 */

/**
 * 全站收藏
 */

define(function () {
    var cookieObj = {};

    (function () {
        var pluses = /\+/g;

        function raw(s) {
            return s;
        }

        function decoded(s) {
            return decodeURIComponent(s.replace(pluses, ' '));
        }

        cookieObj = function (key, value, options) {

            // write
            if (value !== undefined) {
                options = $.extend({}, cookieObj.defaults, options);

                if (value === null) {
                    options.expires = -1;
                }

                if (typeof options.expires === 'number') {
                    var days = options.expires, t = options.expires = new Date();
                    t.setDate(t.getDate() + days);
                }

                value = cookieObj.json ? JSON.stringify(value) : String(value);

                return (document.cookie = [
                    encodeURIComponent(key), '=', cookieObj.raw ? value : encodeURIComponent(value),
                    options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    options.path    ? '; path=' + options.path : '',
                    options.domain  ? '; domain=' + options.domain : '',
                    options.secure  ? '; secure' : ''
                ].join(''));
            }

            // read
            var decode = cookieObj.raw ? raw : decoded;
            var cookies = document.cookie.split('; ');
            for (var i = 0, l = cookies.length; i < l; i++) {
                var parts = cookies[i].split('=');
                if (decode(parts.shift()) === key) {
                    var cookie = decode(parts.join('='));
                    return cookieObj.json ? JSON.parse(cookie) : cookie;
                }
            }

            return null;
        };

        cookieObj.defaults = {};

    })();

    var tpl = [
        '<div class="sys-dialog-hint">',
            '<div class="bd">',
                '<p class="title"><i class="icon icon-sys1-success"></i>收藏成功！</p>',
                '<p class="hint">请在“我的行程-我的收藏”中查看</p>',
            '</div>',
        '</div>'
    ].join('');

    var isPc = !(location.href.indexOf('m.xcds.com.cn') > -1
                    || location.href.indexOf('m.beta.xcds.com.cn') > -1);

    $(function () {
        var timer;
        var $dialog;

        $('body').on('tap', '.js-line-heart', function () {

            // 未登录时
            if (!cookieObj('z')) {
                if (isPc) {
                    $(".js_loginBtn").eq(0).trigger('click');
                }
                else {
                    location.href = '/login/';
                }

                return false;
            }

            var $this = $(this);
            var refId = $this.data('refId');
            var title = $this.data('title');
            var price = $this.data('price');
            var type = $this.data('type');

            if ($this.hasClass('has-hearted')) {
                $.ajax({
                    url: '/r/favorite/delete/',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        refId: refId,
                        type: type
                    },
                    success: function (data) {
                        if (data.code === 0) {
                            var $span = $this.removeClass('has-hearted')
                                .find('span');

                            // 列表页时单独处理
                            if ($this.data('list')) {
                                var text = $.trim($span.text());

                                if (text && text !== '0' && text !== '99+') {
                                    $span.text(+text - 1);
                                }
                            }
                            else {
                                $span.text('收藏');
                            }

                            // 收藏页删除父item
                            if ($this.data('delete')) {
                                $this.closest('.item').remove();
                            }
                        }
                        else {
                            alert(data.msg)
                        }
                    }
                });
            }
            else {
                $.ajax({
                    url: '/r/favorite/add/',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        type: type,
                        pageType: isPc ? 1 : 2,
                        refId: refId,
                        title: title,
                        price: price
                    },
                    success: function (data) {
                        if (data.code === 0) {
                            // var favorNum = data.data.favor_num;

                            // favorNum = favorNum > 99 ? '99+' : favorNum;

                            var $span = $this.addClass('has-hearted')
                                .find('span');
                            var text = '';

                            // 列表页时单独处理
                            if ($this.data('list')) {
                                text = $.trim($span.text());
                            }
                            else {
                                text = '' + $.trim($this.data('count'));
                            }

                            if (text && text !== '99+') {
                                if (text == '99') {
                                    $span.text('99+');
                                }
                                else {
                                    $span.text(+text + 1);
                                }
                            }

                            if (isPc) {
                                clearTimeout(timer);

                                $dialog && $dialog.remove && $dialog.remove();

                                $dialog = $(tpl).appendTo($('body'))
                                    .fadeIn('slow');

                                timer = setTimeout(function () {
                                    $dialog.fadeOut('slow', function () {
                                        $dialog.remove();
                                    });
                                }, 2000);
                            }
                        }
                        else {
                            alert(data.msg);
                        }
                    }
                })
            }

            return false;
        });
    });
})



// WEBPACK FOOTER //
// ./src/module/heart.js